import React from 'react'
import { useSelector } from 'react-redux'

import useOfferList from '@/features/offers/hooks/useOfferList'
import { ApprovalStatus } from '@/features/offers/constants'
import { authSelector } from '@/stores/auth/authSlice'
import { Flex } from '@chakra-ui/react'
import BaseOfferTaskWidget from './BaseOfferTaskWidget'
import OfferTaskButton from './OfferTaskButton'
import { PRApprovalStatus, ApprovalInvitationStatus, PRStatus } from '@eapproval/offer-shared'

const MyPRApprovalWidget = () => {
  const { user } = useSelector(authSelector)
  const { useFetchPRApprovals } = useOfferList()

  const { data: prApprovalResponse } = useFetchPRApprovals({
    page: 1,
    pageSize: 0,
    filters: {
      actionUser: user?.fullName || '',
    },
  })

  const baseLink = '/offers/pr-approvals'

  const actionUserQuery = `actionUser=${encodeURIComponent(user?.fullName || '')}`
  const rows =
    (Array.isArray(prApprovalResponse?.data?.data) && prApprovalResponse?.data?.data) ||
    (Array.isArray(prApprovalResponse?.data) && prApprovalResponse?.data) ||
    []

  const validPRStatus = [PRStatus.APPROVED, PRStatus.REJECTED, PRStatus.PARKED, PRStatus.SUBMITTED]

  const upcomingCount = rows.filter(
    (item) => item.approvalStatus === PRApprovalStatus.UPCOMING && validPRStatus.includes(item.PRStatus)
  ).length

  const actionRequiredStatus = [PRApprovalStatus.REQUIRED, PRApprovalStatus.PARKED, ApprovalInvitationStatus.INVITED]
  const actionRequiredCount = rows.filter(
    (item) => actionRequiredStatus.includes(item.approvalStatus) && validPRStatus.includes(item.PRStatus)
  ).length

  const processedStatus = [PRApprovalStatus.APPROVED, PRApprovalStatus.REJECTED, ApprovalInvitationStatus.REPLIED]
  const processedCount = rows.filter(
    (item) => processedStatus.includes(item.approvalStatus) && validPRStatus.includes(item.PRStatus)
  ).length

  return (
    <BaseOfferTaskWidget title={'My PR Approval'}>
      <Flex gap="5" direction={['column', 'row']} wrap="wrap">
        <OfferTaskButton
          color="teal"
          buttonText={'Upcoming'}
          count={upcomingCount}
          link={
            baseLink +
            `?approvalStatus=${PRApprovalStatus.UPCOMING}&${actionUserQuery}&PRStatus=${validPRStatus.join('%2C')}`
          }
        />
        <OfferTaskButton
          color="teal"
          buttonText={'Action Required'}
          count={actionRequiredCount}
          link={
            baseLink +
            `?approvalStatus=${actionRequiredStatus.join('%2C')}&${actionUserQuery}&PRStatus=${validPRStatus.join('%2C')}`
          }
        />
        <OfferTaskButton
          color="teal"
          buttonText={'Processed'}
          count={processedCount}
          link={
            baseLink +
            `?approvalStatus=${processedStatus.join('%2C')}&${actionUserQuery}&PRStatus=${validPRStatus.join('%2C')}`
          }
        />
      </Flex>
    </BaseOfferTaskWidget>
  )
}

export default MyPRApprovalWidget
